module.exports = __webpack_public_path__ + "static/media/logInImg.aa04fc49.png";